import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=0b44ab2b"
import script from "./normal.vue?vue&type=script&lang=js"
export * from "./normal.vue?vue&type=script&lang=js"
import style0 from "./normal.vue?vue&type=style&index=0&id=0b44ab2b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports